import * as React from 'react'
import loadable from '@loadable/component'

import { styled } from '@thg-commerce/gravity-theme'

const MatalanShareIcon = loadable(
  () => import('@thg-commerce/gravity-icons/src/components/MatalanShareIcon'),
  { ssr: true, fallback: <div style={{ width: 24, height: 24 }} /> },
)

const StyledShareButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 48px;
  height: 48px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
`

interface ShareButtonProps {
  sku?: string
  pdpLink?: string
  isMobileApp?: boolean
  enableInAppShare?: boolean
}

declare global {
  interface Window {
    ReactNativeWebView?: { postMessage: (data: string) => void }
  }
}

const ShareButton: React.FC<ShareButtonProps> = React.memo(
  ({ sku, pdpLink, isMobileApp, enableInAppShare }) => {
    const handleShare = React.useCallback(() => {
      const message = JSON.stringify({
        sku,
        pdpLink,
        eventCategory: 'SHARE_PRODUCT',
      })

      window.ReactNativeWebView?.postMessage(message)
    }, [sku, pdpLink])

    return isMobileApp && enableInAppShare ? (
      <StyledShareButton onClick={handleShare}>
        <MatalanShareIcon />
      </StyledShareButton>
    ) : null
  },
)

export default ShareButton
